import { render, staticRenderFns } from "./ReminderList.vue?vue&type=template&id=6908f52e&scoped=true&lang=pug"
import script from "./ReminderList.vue?vue&type=script&lang=js"
export * from "./ReminderList.vue?vue&type=script&lang=js"
import style0 from "./ReminderList.vue?vue&type=style&index=0&id=6908f52e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6908f52e",
  null
  
)

export default component.exports